import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["spinner-border text-primary flex-shrink-0", [_ctx.sm && 'spinner-border-sm']]),
    role: "status"
  }, null, 2))
}